module.exports = __webpack_public_path__ + "static/media/se.bb5aefe4.svg";